export default "__VITE_ASSET__BYpfMlhI__"